module.exports = __webpack_public_path__ + "media/images/bird-inverted-1feea2615aa56435820f17ad10d08a7e.png";